var BasicProfilePresenter = /** @class */ (function () {
    function BasicProfilePresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    BasicProfilePresenter.prototype.getClientcategoryNRI = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getClientcategoryNRI.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.getClientDetailsData = function (req) {
        var _this = this;
        this.actions.clientDetails.hideError();
        this.actions.clientDetails.loader();
        this.usecase.clientDetails.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.clientDetails.getClientDetailsData(data);
                _this.actions.clientDetails.stopLoader();
            },
            onError: function (error) {
                _this.actions.clientDetails.setError({ isOpen: true, error: error });
                _this.actions.clientDetails.stopLoader();
            },
        }, req);
    };
    BasicProfilePresenter.prototype.getProfilePicData = function (req) {
        var _this = this;
        this.actions.getProfilePic.hideError();
        this.actions.getProfilePic.loader();
        this.usecase.GetProfilePic.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.getProfilePic.getProfilePicData(data);
                _this.actions.getProfilePic.stopLoader();
            },
            onError: function (error) {
                _this.actions.getProfilePic.setError({ isOpen: true, error: error });
                _this.actions.getProfilePic.stopLoader();
            },
        }, req);
    };
    BasicProfilePresenter.prototype.getRegisterdDeviceData = function (req) {
        var _this = this;
        this.actions.getRegisteredDeviceDetails.hideError();
        this.actions.getRegisteredDeviceDetails.loader();
        this.usecase.getRegisteredDeviceDetails.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.getRegisteredDeviceDetails.getRegisterdDeviceData(data);
                _this.actions.getRegisteredDeviceDetails.stopLoader();
            },
            onError: function (error) {
                _this.actions.getRegisteredDeviceDetails.setError({
                    isOpen: true,
                    error: error,
                });
                _this.actions.getRegisteredDeviceDetails.stopLoader();
            },
        }, req);
    };
    BasicProfilePresenter.prototype.DeleteProfilePicData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.deleteProfilePic.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.deRegisterDeviceData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.deRegisterDeviceDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.SaveProfilePicData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.saveProfilePic.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.registerDeviceData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.registerDeviceDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.advisorRatingDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.advisorRating.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.nomineeDetailsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.nomineeDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.getBrokerageSegmentData = function (req) {
        var useCase = this.usecase.getBrokerageSegmentDetails;
        return new Promise(function (resolve, reject) {
            useCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.getRmDetailsData = function () {
        var _this = this;
        this.actions.getRmDetails.hideError();
        this.actions.getRmDetails.loader();
        this.usecase.getRmDetails.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.getRmDetails.getRmDetailsData(data);
                _this.actions.getRmDetails.stopLoader();
            },
            onError: function (error) {
                _this.actions.getRmDetails.setError({ isOpen: true, error: error });
                _this.actions.getRmDetails.stopLoader();
            },
        }, null);
    };
    BasicProfilePresenter.prototype.whatsappContentDetailsData = function (req) {
        var useCase = this.usecase.whatsappConsent;
        return new Promise(function (resolve, reject) {
            useCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.downloadKYCData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.downloadKYCData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.defaultExchangeData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.DefaultExchange.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.wealthAdvisorData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.wealthAdvisor.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.saveLeadData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.saveLead.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.mandateCalendarData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mandateCalendar.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.deleteUpiData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.deleteUpi.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.generateSecretKeyEtotp = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.generateSecretKeyEtotp.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, undefined);
        });
    };
    BasicProfilePresenter.prototype.ValidateSecretKeyEtotp = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateSecretKeyEtotp.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.validatePasswordDisableEtotp = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validatePasswordDisableEtotp.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.disableEtotp = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.disableEtotp.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.disableEtotpGenerateOtp = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.disableEtotpGenerateOtp.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, undefined);
        });
    };
    BasicProfilePresenter.prototype.changePassword = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.changePassword.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    BasicProfilePresenter.prototype.mandateLinkedSip = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mandateLinkedSip.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    return BasicProfilePresenter;
}());
export default BasicProfilePresenter;
